<template>
	<th class="px-2 py-1 md:px-6 lg:py-3 border-b border-gray-200 bg-gray-50" :class="{ 'cursor-pointer': cursorPointer }">
		{{ label }}
		<span v-if="currentSort">
			<font-awesome-icon :icon="['fa', 'sort-amount-down']" class="w-5 h-5 pr-1" size="lg" v-if="currentSortDir === 'asc'" />
			<font-awesome-icon :icon="['fa', 'sort-amount-up-alt']" class="w-5 h-5 pr-1" size="lg" v-if="currentSortDir === 'desc'" />
		</span>
	</th>
</template>
<script>
export default {
	name: 'OverviewTableHeader',
	props: {
		currentSort: {},
		currentSortDir: {},
		sortby: {},
		label: {
			required: true,
			type: String,
		},
		cursorPointer: { default: true },
	},
};
</script>
